import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsEmployeesBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsEmployeesBlockEntity
